import { Flex, Text } from '@chakra-ui/react';
import { PortalContainerContext } from '@voly/ui-components/src/v2/providers/chakra';
import VSelect from '@voly/ui-components/src/v2/VSelect.jsx';
import { useContext } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { TGroupConfig } from '../organisms/CustomFieldGroupsSettings';

interface AddToGroupProps {
  options: TGroupConfig[];
  onSelect: (groupId: string) => void;
  selectedGroupId?: string;
}

const AddToGroup = ({ options, onSelect, selectedGroupId }: AddToGroupProps) => {
  const portalContainer = useContext(PortalContainerContext);

  const groupItems = options.map((option) => ({ label: option.title, value: option?.id }));
  const selectedGroup = selectedGroupId ? [selectedGroupId] : [];

  return (
    <Flex flexDirection="column">
      <Text>{translate('add_to_group')}</Text>
      <VSelect
        collection={{ items: groupItems }}
        placeholder={translate('select_a_group')}
        value={selectedGroup}
        onValueChange={({ value }: { value: string[] }) => onSelect(value[0])}
        multiple={false}
        groupBy={undefined}
        menuPortalTarget={portalContainer?.current}
        menuPosition="fixed"
      />
    </Flex>
  );
};

export default AddToGroup;
